import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useWindowSelection } from "../objectSelection";
import { isResourceInState } from "../../redux/sensorAnalysis";
import { resources } from "../../redux/sensorAnalysisConstants";

export const WindowClickDetector = ({ handleWindowClick }) => {
  const { selectedPolygonYUp } = useWindowSelection();

  const sensoranalysisState = useSelector(
    (state) => state.sensorAnalysis.sensorAnalysisState
  );

  const isSelectionActive = isResourceInState(
    sensoranalysisState,
    resources.SELECTABLE_WINDOWS
  );

  useEffect(() => {
    if (!isSelectionActive || !selectedPolygonYUp) return;
    handleWindowClick(selectedPolygonYUp);
  }, [isSelectionActive, handleWindowClick, selectedPolygonYUp]);
};
